'use strict';

// TODO: should use transclusion
// e.g. <cf-knowledge-base target="roles">text to be displayed</cf-knowlege-base>

angular.module('contentful').directive('cfKnowledgeBase', [
  'require',
  require => {
    const KnowledgeBaseComponent = require('components/shared/knowledge_base_icon/KnowledgeBase.es6')
      .default;

    return {
      restrict: 'E',
      template: '<cf-component-bridge component="component" />',
      scope: {
        text: '@',
        target: '@',
        inlineText: '@',
        cssClass: '@'
      },
      controller: [
        '$scope',
        $scope => {
          $scope.component = KnowledgeBaseComponent({
            target: $scope.target,
            text: $scope.text,
            inlineText: $scope.inlineText,
            cssClass: $scope.cssClass
          });
        }
      ]
    };
  }
]);



// WEBPACK FOOTER //
// ./src/javascripts/components/shared/knowledge_base_icon/cf_knowledge_base_directive.js